var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDownOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7729 5.27344H3.2276C2.88131 5.27344 2.68795 5.63906 2.9024 5.88867L8.67506 12.5824C8.84029 12.774 9.15845 12.774 9.32545 12.5824L15.0981 5.88867C15.3126 5.63906 15.1192 5.27344 14.7729 5.27344Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDownOutlined);
export default __webpack_public_path__ + "static/media/CaretDownOutlined.1eeaa6a48464b00eb3445abf0638affd.svg";
export { ForwardRef as ReactComponent };